import React, { FC } from 'react'
import EnvironmentMetricsList from 'components/metrics/EnvironmentMetricsList'

type FeatureMetricsSectionProps = {
  environmentId?: string
  projectId: number
}

export const FeatureMetricsSection: FC<FeatureMetricsSectionProps> = ({
  environmentId,
  projectId,
}) => {
  if (!environmentId) {
    return null
  }

  return (
    <EnvironmentMetricsList
      environmentId={environmentId}
      projectId={projectId}
    />
  )
}
